import React from 'react';
import { connect } from 'react-redux';
import { fetchActiveUsersListData, mostActiveUsersListFilterSelected } from '../../../actions/analytics/isiAnywhere/mostActiveList.js';
import { useRef } from 'react';
//import { Bar, getElementsAtEvent } from 'react-chartjs-2';
import { withOktaAuth } from '@okta/okta-react';

class ActiveUsersList extends React.Component {

    constructor(props) {
        super(props);

        this.chartRef = React.createRef();
    }

    getInitialListData = async () => {

        if (this.props.authState.isAuthenticated) {
            let authObj = {};
            const userInfo = await this.props.oktaAuth.getUser();
            //console.log("USER INFO", userInfo);
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            console.log("Getting Most Acitve USers Data.");
            await this.props.fetchActiveUsersListData(authObj.token);

        }
    }

    componentDidMount() {
        //call function to get API data from Actions
        if (Object.keys(this.props.user).length === 0) {
            this.getInitialListData();
        }
    }



    onClickFilter = async (event) => {
        console.log("Active Users Filter Clicked: ", event.target.innerText);
        await this.props.mostActiveUsersListFilterSelected(event.target.innerText);
    }

    //create table, map through array of objects
    renderList() {
        let curType = "top20"
        if (this.props.curFilter === "Most Active") {
            curType = "top20";
        }
        else if (this.props.curFilter === "Median Active") {
            curType = "middle20"
        }
        else if (this.props.curFilter === "Least Active") {
            curType = "bottom20"
        }
        else {
            curType = "top20"
        }
        //filter list based on current user type filter
        let filteredList = [];
        if (!this.props.isLoading) {
            filteredList = this.props.userList.filter(curUser => curUser.type === curType);
        }

        //loop through filtered list to create and return elements list
        return filteredList.map((user, index) => {
            const key = `${user.name}-${user.email}-${index}`;
            return (
                <tr key={key}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.totalClickCount}</td>
                </tr>
            )
        });
    }

    render() {


        return (
            <div class="card">
                <div class="card-header">
                    <div class="card-head-row">
                        <div class="card-title">Top Users</div>
                        <div class="card-tools">
                            <ul class="nav nav-pills nav-secondary nav-pills-no-bd nav-sm" id="pills-tab" role="tablist">
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link active intuitive-pill" id="pills-top-active" data-toggle="pill" href="#pills-top-active" role="tab" aria-selected="true" >Most Active</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter} >
                                    <a class="nav-link show" id="pills-mid-active" data-toggle="pill" href="#pills-mid-active" role="tab" aria-selected="false">Median Active</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link" id="pills-least-active" data-toggle="pill" href="#pills-least-active" role="tab" aria-selected="false">Least Active</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div id="scrollable-card-body" class="card-body">
                    {/* <div class="card-sub">
                        This is the basic table view of the ready dashboard :
                    </div> */}
                    <table class="table mt-1">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Clicks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.isLoading ? <div class="loader loader-primary"></div> : this.renderList()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    console.log("State MOST Active User List :", state);
    return { user: state.user, userList: state.mostActiveUsersList, isLoading: state.mostActiveUsersListIsLoading, curFilter: state.selectedMostActiveUserFilter };
}

export default connect(mapStateToProps, { fetchActiveUsersListData, mostActiveUsersListFilterSelected })(withOktaAuth(ActiveUsersList));
//export default ActiveUsersList;